import { Component, Input, OnInit, ViewChild, Host, Optional } from '@angular/core';
import { FormControl, AbstractControl } from '@angular/forms';
import { EasyFormComponent } from '../form/form.component';
import { FMSUtilityService } from '../../services/utility/utility.service';
import { FormGroupComponent } from '../form-group/form-group.component';
import { FormErrorComponent } from '../error/error.component';
import { BaseInputComponent } from '../base-input/base-input.component';

@Component({
    selector: 'submitInput',
    templateUrl: 'submit-input.component.html',
    styleUrls: [
        '../base-input/base-input.component.css'
    ]
})
export class FormSubmitComponent {

    @Input() value: string = 'Submit';
    get isFormValid() {
        return this.parentForm.formGroup.valid;
    }

    constructor( @Host() private parentForm: EasyFormComponent) {
    }

    submit() {
        this.parentForm.submit();
    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/easyForms/components/submit/submit-input.component.ts